import React, { Component } from 'react'
import M from 'materialize-css';

export default class PurchasePriceInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      localPurchasePrice: this.props.values.purchasePrice
    }

    this.timer = null;
  }

  componentDidMount() {
    // Ensure that label does not overlap with input when prefilled
    M.updateTextFields();
  }

  handleChange = (e) => {

    if (e?.target?.value === undefined || e?.target?.value === null || typeof(e?.target?.value) !== 'string') return;

    // Input can only be numbers. Ensure now that it is not negative and that the length fits for a purchase price.
    e.target.value = e.target.value.replace('-', '');
    if (e.target.value.length > 8) e.target.value = e.target.value.slice(0,8);

    let value = "";
    try {
      value = parseFloat(e.target.value);
      if (isNaN(value)) value = "";
    }
    catch {
      value = "";
    }

    // In case of very fast inputs, e.g., many zeros, the input field will
    // show wrong values, potentially due to race conditions.
    // Therefore, use a local state to show in the input field and use a timeout
    // to avoid spamming the update function. As an additional benefit, this will
    // reduce load on the server.
    this.setState({
      localPurchasePrice: value
    }, () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const newEvent = {
          target: {
            id: e.target.id,
            value: this.state.localPurchasePrice
            //value: value
          }
        }
        return this.props.handleChange(newEvent);
      }, 500)
    });

  };


  render() {
    return (
      <div>
        <form action="" onSubmit={this.props.handleSubmit}>
          <div className="input-field">
            <i className="material-icons prefix grey-text">euro_symbol</i>
            <input type="number" className="no-arrows-input" id="purchasePrice" value={this.state.localPurchasePrice} onChange={this.handleChange} />
            <label htmlFor="purchasePrice">Kaufpreis</label>
          </div>
        </form>
      </div>
    )
  }
}
